import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { CircularProgress } from '@mui/material'

import { logout as logoutAction } from '../../store/auth/actions'
import { showGenericMessage as showGenericMessageAction } from '../../store/app/actions'
import { changeUserPhoto as changeUserPhotoAction, updateUserData } from '../../store/user/actions'

import Card from './Card'
import ImageUploadFile from '../shared/ImageUploadFile'
import EditForm from '../form/EditUserForm'

import {
  cardTop,
  userPhotoContainer,
  userPhoto,
  photoActions
} from './styles/UserCard.style.js'

const UserCard = ({
  logout,
  user,
  showGenericMessage,
  changeUserPhoto,
  isPhotoChanging,
  updateUserData,
  translation,
  lang,
  editFormRef
}) => {
  const renderUpload = () => (
    <ImageUploadFile
      translation={translation}
      onUploadSuccess={({ url }) => changeUserPhoto({ url, translation })}
      onUploadFailure={(erro) => showGenericMessage(erro)}
      onRemove={changeUserPhoto}
      hasPhoto={user.photo_url !== null}
    />
  )
  return (
    <Card>
      <div className={cardTop}>
        <EditForm
          formRef={editFormRef}
          translation={translation}
          initialValues={user}
          onSubmit={(data) => updateUserData(user, data, translation)}
          lang={lang}
        />
        <div style={{ alignSelf: 'flex-start' }}>
          {user.photo_url && (
            <div className={userPhotoContainer}>
              {!isPhotoChanging
                ? (
                  <img
                    className={userPhoto}
                    src={user.photo_url}
                    alt={user.name}
                  />
                )
                : <CircularProgress size={36} />
              }
              <div className={photoActions} data-photo-actions>
                {renderUpload()}
              </div>
            </div>
          )}

          {!user.photo_url && renderUpload()}
        </div>
      </div>
    </Card>
  )
}

UserCard.propTypes = {
  user: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  showGenericMessage: PropTypes.func.isRequired,
  changeUserPhoto: PropTypes.func.isRequired,
  isPhotoChanging: PropTypes.bool.isRequired,
  updateUserData: PropTypes.func,
  translation: PropTypes.func,
  lang: PropTypes.string,
  editFormRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ])
}

const mapStateToProps = ({ auth, user }) => ({
  user: auth.user,
  isPhotoChanging: user.isPhotoChanging
})

const mapDispatchToPros = dispatch =>
  bindActionCreators(
    {
      logout: logoutAction,
      showGenericMessage: showGenericMessageAction,
      changeUserPhoto: changeUserPhotoAction,
      updateUserData: updateUserData
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToPros)(UserCard)
